import React from 'react';

const Footer = () => (
  <nav className="nav-bar text-white  footer">
    <p className="text-center">@Copy right 2022 --- Maths-Magician</p>
  </nav>
);
export default Footer;
